import { ScopeT, BlockT, UserScopeT, UserScopesT } from 'business/definitions';
import { camelize } from 'helpers/syntaxHelper';

const camelizeAny = (any: ScopeT['expression']['any']) =>
    any?.map((scopeBlock: BlockT) => ({
        ...scopeBlock,
        block: camelize(scopeBlock.block),
    }));

export const camelizeScopeBlockNames = (scopes: ScopeT[]): ScopeT[] =>
    scopes.map((initialScope: ScopeT) => {
        if (!initialScope.expression) {
            return initialScope;
        }
        let scope = initialScope;
        if (scope.expression.block) {
            scope = {
                ...scope,
                expression: {
                    ...scope.expression,
                    block: camelize(scope.expression.block),
                },
            };
        }
        if (scope.expression.any) {
            scope = {
                ...scope,
                expression: {
                    ...scope.expression,
                    any: camelizeAny(scope.expression.any),
                },
            };
        }
        return scope;
    });

export const getUserScopesPostProcessingMiddleware = (
    userScopes: UserScopesT,
): UserScopesT =>
    userScopes.map((userScope: UserScopeT) => ({
        ...userScope,
        blocks: userScope.blocks.map((block) => ({
            ...block,
            name: camelize(block.name),
        })),
    }));
